/**
 * PATH: packages/ui/src/kanban/api-fetch/cardDocuments.ts
 * FILE_ID: UI-KANBAN-FETCH-CARDDOCS-001
 * PURPOSE: Keep card document transport separate from the primary card API.
 * WHY: Document payloads are intent-loaded and must not grow the card transport module.
 * FLOW: card id + kind -> document HTTP request -> document payload.
 * DEPENDENCIES: ApiFetchContext; KanbanApi.
 * RELATED: cards.ts; components/KanbanCardWorkbookModal.tsx.
 */
import type { KanbanApi } from '../api'
import type { CardDocumentPayload } from '../types'
import type { ApiFetchContext } from './context'

export function createCardDocumentsApi(ctx: ApiFetchContext) {
  const { _request } = ctx
  return {
    getCardWorkbook: (cardId) =>
      _request<CardDocumentPayload>('GET', `/cards/${cardId}/workbook/`),
    saveCardWorkbook: (cardId, data) =>
      _request<CardDocumentPayload>('PUT', `/cards/${cardId}/workbook/`, { data }),
    getCardFlowchart: (cardId) =>
      _request<CardDocumentPayload>('GET', `/cards/${cardId}/flowchart/`),
    saveCardFlowchart: (cardId, data) =>
      _request<CardDocumentPayload>('PUT', `/cards/${cardId}/flowchart/`, { data }),
  } satisfies Partial<KanbanApi>
}
